import { LegalLayout, H2, P, UL, LI } from "../components/site/LegalLayout";
import { EMAIL, PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "../lib/site";

export default function Accessibility() {
  return (
    <LegalLayout
      title="ACCESSIBILITY STATEMENT"
      updated="June 2026"
      intro="We want every customer to be able to use this website and do business with us. If anything on this site is hard for you to access, call 740-747-1123 and we will help you directly."
      testid="accessibility-page"
    >
      <H2>Our Commitment</H2>
      <P>
        Scrapmans Metal Recycling LLC is committed to making this website usable for people of all abilities,
        including customers who use screen readers, keyboard navigation, screen magnification or other
        assistive technology.
      </P>

      <H2>Standards We Aim For</H2>
      <P>
        We work toward conformance with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA as our
        reference standard. Steps taken on this site include:
      </P>
      <UL>
        <LI>Descriptive text alternatives for meaningful images.</LI>
        <LI>A logical heading structure and page titles on every page.</LI>
        <LI>Keyboard-accessible navigation, links, form fields and buttons.</LI>
        <LI>High-contrast text and large, clearly labeled phone and directions buttons.</LI>
        <LI>A responsive layout that works with zoom and on small screens.</LI>
        <LI>Form fields with visible labels or placeholders and clear error and success messages.</LI>
      </UL>

      <H2>Known Limitations</H2>
      <P>
        Accessibility is ongoing work, not a one-time project. We are aware of the following limitations:
      </P>
      <UL>
        <LI>
          Our contact section includes an embedded Google Maps frame. That map is a third-party component we
          do not control, and its accessibility depends on Google. Our full address is always listed in plain
          text next to it, and we are happy to give directions over the phone.
        </LI>
        <LI>
          Some pages use motion and scroll animations. These are decorative only and do not hide content. If
          you have reduced-motion enabled in your device or browser settings, we are continuing to improve
          how the site respects that preference.
        </LI>
      </UL>

      <H2>Need Help? Contact Us Directly</H2>
      <P>
        If you have trouble using any part of this website, or you need information from it in another
        format, contact us and a person will assist you. We can take your quote request, give you pricing
        information, confirm hours and give directions entirely over the phone.
      </P>
      <P>
        Phone: {PHONE_DISPLAY}
        <br />
        Email:{" "}
        <a href={`mailto:${EMAIL}`} className="text-red-700 font-semibold underline underline-offset-2">
          {EMAIL}
        </a>
        <br />
        Mail: Scrapmans Metal Recycling LLC, {ADDRESS_LINE1}, {ADDRESS_LINE2}
      </P>
      <P>
        Please tell us the page or feature involved and what happened. We take accessibility feedback
        seriously and will work with you to resolve the issue and fix it on the site.
      </P>
    </LegalLayout>
  );
}
